import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { PriceEstimationContent, EstimationData } from './PriceEstimationContent';
import './PriceEstimationReport.scss';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  estimation: EstimationData;
}

export const PriceEstimationReport: React.FC<Props> = ({
  isOpen,
  onClose,
  estimation
}) => {
  // Close on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const shareUrl = `${window.location.origin}/price-estimation-report/${estimation.estimation_id}`;

  return ReactDOM.createPortal(
    <div className="price-estimation-report-overlay price-estimation-report-print-container">
      <PriceEstimationContent 
        estimation={estimation} 
        onClose={onClose}
        shareUrl={shareUrl}
      />
    </div>,
    document.body
  );
};
